export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_agents-legend/artifacts/niza2ch4_WhatsApp%20Image%202026-07-09%20at%2016.29.31%20%282%29.webp",
  event: "https://customer-assets.emergentagent.com/job_agents-legend/artifacts/s6mp5mk3_WhatsApp%20Image%202026-07-09%20at%2016.29.31%20%283%29.webp",
  g1: "https://customer-assets.emergentagent.com/job_agents-legend/artifacts/u8hg3ggb_WhatsApp%20Image%202026-07-09%20at%2016.29.30%20%283%29.jpeg",
  g2: "/mood/g_couple.jpg",
  g3: "/mood/g_rake.jpg",
  g4: "/mood/g_dust.jpg",
  vision: "/mood/g_bw.jpg",
  join: "https://customer-assets.emergentagent.com/job_agents-legend/artifacts/blc2udsj_WhatsApp%20Image%202026-07-09%20at%2016.29.31.webp",
};

export const CONTENT = {
  nav: { event: "The Event", location: "The Land", vision: "The Vision", participate: "Participate", join: "Waitlist" },
  hero: {
    kicker: "Calanchi di Pisticci · Basilicata, Italy",
    title: "LEGEND",
    sub: "A legend rises from the clay",
    desc: "Music, art and an ancient landscape converge for a single night — in a desert of clay sculpted by millions of years of silence.",
    date: "August 12, 2026",
    cta: "Be among the first",
    scroll: "Begin the descent",
  },
  event: {
    kicker: "I — The Event",
    title: "From last light to first light",
    headlinerLabel: "Headliner",
    headliner: "Agents of Time",
    headlinerDesc:
      "The acclaimed Italian trio brings its live performance to the natural amphitheatre of the Calanchi — a set that unfolds as dusk surrenders to a night suspended between earth and sky.",
    items: [
      { label: "Date", value: "August 12, 2026 · from sunset to sunrise" },
      { label: "Place", value: "Calanchi di Pisticci, Matera — Basilicata, Italy" },
      { label: "Format", value: "A single stage carved into the landscape · an intentionally limited audience" },
      { label: "Experience", value: "Site-specific art, light drawn upon the ridges, the food and wine of Lucania" },
    ],
  },
  location: {
    kicker: "II — The Land",
    title: "A landscape older than memory",
    body1:
      "The Calanchi di Pisticci are hills of pale and golden clay, carved by wind and water into ridges, hollows and spires. At dusk the entire valley ignites — ochre, amber, then shadow — a theatre shaped by nothing but time.",
    body2:
      "A few kilometres from the Ionian Sea and from Matera, beneath the whitewashed town of Pisticci, this silent expanse awaits. It is here that Legend takes form.",
    mapTitle: "Find us",
    mapDesc: "Legend — within the Calanchi di Pisticci, Province of Matera",
  },
  vision: {
    kicker: "III — The Vision",
    title: "Why Legend",
    p1: "Legend was born of a simple conviction: that music belongs where time stands still. For one night each year, the Calanchi become a temporary city of sound, light and gathering — raised at dusk, dissolved by dawn, leaving nothing behind but memory.",
    p2: "This is not another festival. It is a rite — an encounter between art and an ancient land, conceived in profound respect for its fragile equilibrium, and destined to be spoken of long after the last light fades.",
    principlesTitle: "The Legend Principles",
    pillars: [
      { title: "The Land is the Stage", desc: "No imposing structures. The scenography is the landscape itself, revealed through light and sound." },
      { title: "A Rite, Not an Event", desc: "One night a year. A deliberately limited audience. A ceremonial approach on foot, preparing each guest for what awaits." },
      { title: "Rooted in Lucania", desc: "The people, artisans, food and wine of Basilicata stand at the centre — never as backdrop, always as protagonist." },
      { title: "Leave No Trace", desc: "What rises at dusk vanishes by dawn. The clay is returned exactly as it was found — the only thing we leave behind is the story." },
      { title: "Radical Wonder", desc: "Legend asks for no spectators: only presence, curiosity and awe. Come as a witness, leave as a storyteller." },
      { title: "One Fire, One Tribe", desc: "Strangers arrive, a tribe departs. In the theatre of the clay, everyone stands in the same light." },
    ],
    quote: "\u201CEvery legend begins in a place unlike any other.\u201D",
    visionsKicker: "Visions",
    visionsTitle: "What will rise from the clay",
    visionsNote: "Concept studies — imagined upon real photographs of the Calanchi.",
    visions: [
      { img: "/mood/mood_camp.jpg", caption: "A camp of canvas and lanterns, at the foot of the hills" },
      { img: "/mood/mood_mandala.jpg", caption: "A gathering written upon the cracked earth" },
      { img: "/mood/mood_stage.jpg", caption: "A single column of light, calling across the dusk" },
    ],
    archiveText: "From our archive — \u201Ca city of embers\u201D, a first study too vast for this world:",
    archiveLabel: "Download the study",
    archiveHref: "/mood/mood_city.jpg",
  },
  participate: {
    kicker: "IV — Participate",
    title: "Built by those who answer the call",
    desc: "Legend is not something you attend — it is something you help bring to life. The temporary city rises through the hands, voices and visions of many.",
    cards: [
      { title: "Artists & Performers", desc: "Land art, light, sound, ritual — propose a work born for the clay, destined to live a single night.", cta: "Answer the call", href: "#join" },
      { title: "Hands & Builders", desc: "The city of one night needs makers, stewards of the land and quiet heroes of the dark hours.", cta: "Answer the call", href: "#join" },
      { title: "Partners & Patrons", desc: "Bind your name to the birth of a new Italian rite — and to a place unlike any other.", cta: "Download the dossier", href: "brochure" },
    ],
  },
  countdown: {
    title: "The night ignites in",
    labels: { days: "Days", hours: "Hours", minutes: "Minutes", seconds: "Seconds" },
    target: "2026-08-12T20:00:00+02:00",
  },
  join: {
    kicker: "V — The Invitation",
    title: "Become part of the Legend",
    desc: "Leave your address to receive word of the lineup, tickets and experiences — rarely, and only when it matters.",
    placeholder: "Your email",
    namePlaceholder: "Your name (optional)",
    button: "Join the waitlist",
    success: "Welcome. You will hear from us when the time comes.",
    already: "You are already with us — we shall meet among the Calanchi.",
    error: "Something went astray. Please try again.",
    brochureTitle: "For partners & press",
    brochureDesc: "Request the Legend presentation dossier — the project, the land, the vision.",
    brochureBtn: "Download the Brochure",
  },
  footer: {
    tagline: "A legend rises from the clay",
    place: "Calanchi di Pisticci (MT) — Basilicata, Italy",
    date: "August 12, 2026",
    rights: "© 2026 Legend. All rights reserved.",
  },
};
